export default () => ({
	orderCompanies: [],
	orderCompaniesLoading: false,
	page: 1,
	per_page: 50,
	additionalData: {}
})
